import React, { FC, useEffect, useMemo, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { CloseOutlined } from '@material-ui/icons';

import TabPanel from '../../Entity/AreaBar/TabPanel';
import ExpirationDocumentsTable, {
  Period,
} from '../Tables/ExpirationDocuments';
import { ICategory } from 'interfaces/category';
import { ISnapshot } from 'services/snapshot';

type Props = {
  open: boolean;
  currentCategory?: ICategory;
  snapshot?: ISnapshot;
  onClose: () => void;
};

type TabPanelProps = {
  period: Period;
  bgColor: string;
};

const periodDays: { [number: number]: TabPanelProps[] } = {
  1: [{ period: 180, bgColor: 'rgb(192, 80, 77)' }],
  2: [{ period: 120, bgColor: '#808080' }],
  3: [{ period: 'EXPIRED', bgColor: 'rgb(0, 0, 0)' }],
};

const DialogCloseToExpiration: FC<Props> = (props) => {
  const { currentCategory, onClose: handleClose, snapshot, open } = props;
  const [value, setValue] = useState(0);
  const [period, setPeriod] = useState<TabPanelProps[]>([]);

  const handleChangeTable = (_: any, value: number) => {
    setValue(value);
  };

  useEffect(() => {
    setValue(0);
    if (currentCategory) {
      setPeriod(periodDays[currentCategory.id]);
    } else {
      setPeriod([]);
    }
  }, [currentCategory]);

  const snapshotDate = useMemo(() => {
    if (snapshot) {
      return `${snapshot.year}-${snapshot.month}-${snapshot.day}`;
    }
    return '';
  }, [snapshot]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-Dialog-title"
      aria-describedby="simple-Dialog-description"
      fullWidth
      maxWidth="md"
    >
      <DialogActions>
        <IconButton onClick={handleClose}>
          <CloseOutlined />
        </IconButton>
      </DialogActions>
      <DialogTitle>
        {currentCategory ? currentCategory.name : ''} - Quadros de alertas
      </DialogTitle>
      <DialogContent style={{ paddingTop: 0, paddingRight: 0, paddingLeft: 0 }}>
        <AppBar position="static">
          <Tabs value={value} onChange={handleChangeTable}>
            {period &&
              period.map((item) => (
                <Tab
                  key={`Tab-${item}`}
                  label={
                    item.period !== 'EXPIRED'
                      ? `Próximo de vencer (${item.period} dias)`
                      : 'Vencidos'
                  }
                />
              ))}
          </Tabs>
        </AppBar>
        {period &&
          period.map((item) => (
            <TabPanel key={`TabPanel-${item.period}`} value={value} index={0}>
              {currentCategory && (
                <ExpirationDocumentsTable
                  period={item.period}
                  categoryId={currentCategory.id}
                  bgColor={item.bgColor}
                  snapshotDate={snapshotDate}
                  color="white"
                />
              )}
            </TabPanel>
          ))}
      </DialogContent>
    </Dialog>
  );
};

export default DialogCloseToExpiration;
